import { OwnedAssistanceProduct } from '@/interfaces';
import { RoadsideProductType } from '../roadside-helpers';

const showChangeRego = (policy: OwnedAssistanceProduct): boolean => {
  // Display when roadsidepolicytype is Standard and NOT CMO and not associate motoring and has a nominated vehicle
  // (Standard/ CMO / associate are mutually exclusive)
  return policy?.roadsidePolicyType === RoadsideProductType.Standard && policy?.hasVehicle;
};

const showChangeVehicle = (policy: OwnedAssistanceProduct): boolean => {
  // Display when roadsidepolicytype is Standard and NOT CMO and not associate motoring and has a nominated vehicle
  // (Standard/ CMO / associate are mutually exclusive)
  return policy?.roadsidePolicyType === RoadsideProductType.Standard && policy?.hasVehicle;
};

export const RSAEditRules = {
  showChangeRego,
  showChangeVehicle,
};
